import {
    ADD_PROCESS_FAIL,
    ADD_PROCESS_REQUEST,
    ADD_PROCESS_RESET,
    ADD_PROCESS_SUCCESS,
    GET_PROCESSES_FAIL,
    GET_PROCESSES_REQUEST,
    GET_PROCESSES_RESET,
    GET_PROCESSES_SUCCESS,
    UPDATE_PROCESS_FAIL,
    UPDATE_PROCESS_REQUEST,
    UPDATE_PROCESS_RESET,
    UPDATE_PROCESS_SUCCESS,
    DELETE_PROCESS_FAIL,
    DELETE_PROCESS_REQUEST,
    DELETE_PROCESS_RESET,
    DELETE_PROCESS_SUCCESS,
  } from '../constants/processConstants';
  
  export const addProcessReducer = (state = {}, action) => {
    switch (action.type) {
      case ADD_PROCESS_REQUEST:
        return { loadingAddProcess: true };
      case ADD_PROCESS_SUCCESS:
        return {
          loadingAddProcess: false,
          addProcessData: action.payload,
        };
      case ADD_PROCESS_FAIL:
        return {
          loadingAddProcess: false,
          errorAddProcess: action.payload,
        };
      case ADD_PROCESS_RESET:
        return {};
      default:
        return state;
    }
  };
  
  export const getProcessesReducer = (state = {}, action) => {
    switch (action.type) {
      case GET_PROCESSES_REQUEST:
        return { loadingGetProcesses: true };
      case GET_PROCESSES_SUCCESS:
        return { loadingGetProcesses: false, getProcessesData: action.payload };
      case GET_PROCESSES_FAIL:
        return { loadingGetProcesses: false, errorGetProcesses: action.payload };
      case GET_PROCESSES_RESET:
        return {};
      default:
        return state;
    }
  };
  
  export const updateProcessReducer = (state = {}, action) => {
    switch (action.type) {
      case UPDATE_PROCESS_REQUEST:
        return { loadingUpdateProcess: true };
      case UPDATE_PROCESS_SUCCESS:
        return {
          loadingUpdateProcess: false,
          updateProcessData: action.payload,
        };
      case UPDATE_PROCESS_FAIL:
        return {
          loadingUpdateProcess: false,
          errorUpdateProcess: action.payload,
        };
      case UPDATE_PROCESS_RESET:
        return {};
      default:
        return state;
    }
  };
  
  export const deleteProcessReducer = (state = {}, action) => {
    switch (action.type) {
      case DELETE_PROCESS_REQUEST:
        return { loadingDeleteProcess: true };
      case DELETE_PROCESS_SUCCESS:
        return {
          loadingDeleteProcess: false,
          deleteProcessData: action.payload,
        };
      case DELETE_PROCESS_FAIL:
        return {
          loadingDeleteProcess: false,
          errorDeleteProcess: action.payload,
        };
      case DELETE_PROCESS_RESET:
        return {};
      default:
        return state;
    }
  };